<template>
  <div>
    <div v-if="!$isScopedPolicyMenuHidden('fee_hidden_items.origin_usage_type')" class="mt-3 d-flex justify-content-between align-items-center">
      <div class="filter-label">{{$t('bill.origin_usage_type')}}</div>
      <div class="d-flex align-items-center">
        <filter-condition :formData="formData" filterKey="origin_usage_type" :hiddenOpts="['not_equals']" />
        <base-select
          v-model="formData.origin_usage_type"
          :selectStyle="{maxWidth: '165px'}"
          :options="options.origin_usage_type"
          @dropdownChange="v => dropdownChange('origin_usage_type', v)"
          dropdownItemWordWrap
          :select-props="{ placeholder: $t('bill.text_49'), mode: 'multiple' }" />
      </div>
    </div>
    <div v-if="!$isScopedPolicyMenuHidden('fee_hidden_items.origin_record_type')" class="mt-3 d-flex justify-content-between align-items-center">
      <div class="filter-label">{{$t('meter.origin_record_type')}}</div>
      <div class="d-flex align-items-center">
        <filter-condition :formData="formData" filterKey="origin_record_type" :hiddenOpts="['not_equals']" />
        <base-select
          v-model="formData.origin_record_type"
          :selectStyle="{maxWidth: '165px'}"
          :options="options.origin_record_type"
          @dropdownChange="v => dropdownChange('origin_record_type', v)"
          dropdownItemWordWrap
          :select-props="{ placeholder: $t('bill.text_49'), mode: 'multiple' }" />
      </div>
    </div>
    <div v-if="!$isScopedPolicyMenuHidden('fee_hidden_items.bill_type') && isShowDimensions('bill_type')" class="mt-3 d-flex justify-content-between align-items-center">
      <div class="filter-label">{{$t('bill.bill_type')}}</div>
      <div class="d-flex align-items-center">
        <filter-condition :formData="formData" filterKey="bill_type" :hiddenOpts="['not_equals']" />
        <base-select
          :value="billType"
          :selectStyle="{maxWidth: '165px'}"
          :options="billTypeOpts"
          @change="billTypeChange"
          dropdownItemWordWrap
          :select-props="{ placeholder: $t('bill.text_49'), mode: 'multiple' }" />
      </div>
    </div>
    <div v-if="!$isScopedPolicyMenuHidden('fee_hidden_items.brand') && isShowDimensions('brand')" class="mt-3 d-flex justify-content-between align-items-center">
      <div class="filter-label">{{$t('bill.text_81')}}</div>
      <div class="d-flex align-items-center">
        <filter-condition :formData="formData" filterKey="platform_brand" />
        <base-select
          v-model="formData.platform_brand"
          filterable
          :selectStyle="{maxWidth: '165px'}"
          :options="options.brand"
          @dropdownChange="v => dropdownChange('brand', v)"
          dropdownItemWordWrap
          :select-props="{ placeholder: $t('bill.text_49'), mode: 'multiple' }" />
      </div>
    </div>
    <div v-if="!$isScopedPolicyMenuHidden('fee_hidden_items.account') && isShowDimensions('account')" class="mt-3 d-flex justify-content-between align-items-center">
      <div class="filter-label">{{$t('bill.text_60')}}</div>
      <div class="d-flex align-items-center">
        <filter-condition :formData="formData" filterKey="account" />
        <base-select
          v-model="formData.account"
          filterable
          :selectStyle="{maxWidth: '165px'}"
          @dropdownChange="v => dropdownChange('account', v)"
          :options="options.account"
          dropdownItemWordWrap
          :select-props="{ placeholder: $t('bill.text_49'), mode: 'multiple' }" />
      </div>
    </div>
    <div v-if="!$isScopedPolicyMenuHidden('fee_hidden_items.linked') && isShowDimensions('linked_name')" class="mt-3 d-flex justify-content-between align-items-center">
      <div class="filter-label">{{$t('bill.linked_account')}}</div>
      <div class="d-flex align-items-center">
        <filter-condition :formData="formData" filterKey="linked_name" />
        <base-select
          v-model="formData.linked_name"
          filterable
          :selectStyle="{maxWidth: '165px'}"
          @dropdownChange="v => dropdownChange('linked_name', v)"
          :options="options.linked_name"
          dropdownItemWordWrap
          :select-props="{ placeholder: $t('bill.text_49'), mode: 'multiple' }" />
      </div>
    </div>
    <div v-if="!$isScopedPolicyMenuHidden('fee_hidden_items.cloudprovider') && isShowDimensions('cloudprovider')" class="mt-3 d-flex justify-content-between align-items-center">
      <div class="filter-label">{{$t('bill.text_311')}}</div>
      <div class="d-flex align-items-center">
        <filter-condition :formData="formData" filterKey="cloudprovider" />
        <base-select
          v-model="formData.cloudprovider"
          filterable
          :selectStyle="{maxWidth: '165px'}"
          @dropdownChange="v => dropdownChange('cloudprovider_name', v)"
          :options="options.cloudprovider_name"
          dropdownItemWordWrap
          :select-props="{ placeholder: $t('bill.text_49'), mode: 'multiple' }" />
      </div>
    </div>
    <div v-if="!$isScopedPolicyMenuHidden('fee_hidden_items.region') && isShowDimensions('region')" class="mt-3 d-flex justify-content-between align-items-center">
      <div class="filter-label">{{$t('bill.text_83')}}</div>
      <div class="d-flex align-items-center">
        <filter-condition :formData="formData" filterKey="region" />
        <base-select
          v-model="formData.region"
          filterable
          :selectStyle="{maxWidth: '165px'}"
          :options="options.region"
          @dropdownChange="v => dropdownChange('region', v)"
          dropdownItemWordWrap
          :select-props="{ placeholder: $t('bill.text_49'), dropdownMatchSelectWidth: false, mode: 'multiple' }" />
      </div>
    </div>
    <div v-if="!$isScopedPolicyMenuHidden('fee_hidden_items.origin_region') && isShowDimensions('origin_region')" class="mt-3 d-flex justify-content-between align-items-center">
      <div class="filter-label">{{$t('meter.origin_region')}}</div>
      <div class="d-flex align-items-center">
        <filter-condition :formData="formData" filterKey="origin_region" />
        <base-select
          v-model="formData.origin_region"
          filterable
          :selectStyle="{maxWidth: '165px'}"
          :options="options.origin_region"
          @dropdownChange="v => dropdownChange('origin_region', v)"
          dropdownItemWordWrap
          :select-props="{ placeholder: $t('bill.text_49'), dropdownMatchSelectWidth: false, mode: 'multiple' }" />
      </div>
    </div>
    <div v-if="!$isScopedPolicyMenuHidden('fee_hidden_items.charge_type') && isShowDimensions('charge_type')" class="mt-3 d-flex justify-content-between align-items-center">
      <div class="filter-label">{{$t('bill.text_84')}}</div>
      <div class="d-flex align-items-center">
        <filter-condition :formData="formData" filterKey="charge_type" :hiddenOpts="['not_equals']" />
        <base-select
          v-model="formData.charge_type"
          filterable
          id-key="item_id"
          name-key="item_name"
          :selectStyle="{maxWidth: '165px'}"
          :options="options.chargeType"
          :select-props="{ placeholder: $t('bill.text_49'), allowClear: true }" />
      </div>
    </div>
    <div v-if="isAdminMode && !$isScopedPolicyMenuHidden('fee_hidden_items.domain') && isShowDimensions('domain')" class="mt-3 d-flex justify-content-between align-items-center">
      <div class="filter-label">{{$t('bill.text_76')}}</div>
      <div class="d-flex align-items-center">
        <filter-condition :formData="formData" filterKey="domain" :hiddenOpts="['not_equals']" />
        <base-select
          v-model="formData.domain"
          filterable
          :selectStyle="{maxWidth: '165px'}"
          @dropdownChange="v => dropdownChange('domain', v)"
          :options="options.domain"
          dropdownItemWordWrap
          :select-props="{ placeholder: $t('bill.text_49'), mode: 'multiple' }" />
      </div>
    </div>
    <div v-if="(isAdminMode || isDomainMode) && !$isScopedPolicyMenuHidden('fee_hidden_items.project') && isShowDimensions('project')" class="mt-3 d-flex justify-content-between align-items-center">
      <div class="filter-label">{{$t('bill.project')}}</div>
      <div class="d-flex align-items-center">
        <filter-condition :formData="formData" filterKey="project" :hiddenOpts="['not_equals']" />
        <base-select
          v-model="formData.project"
          filterable
          :selectStyle="{maxWidth: '165px'}"
          :options="options.project"
          @dropdownChange="v => dropdownChange('project', v)"
          dropdownItemWordWrap
          :select-props="{ placeholder: $t('bill.text_49'), mode: 'multiple' }" />
      </div>
    </div>
    <div v-if="!$isScopedPolicyMenuHidden('fee_hidden_items.resource_type') && isShowDimensions('resource_type')" class="mt-3 d-flex justify-content-between align-items-center">
      <div class="filter-label">{{$t('bill.text_73')}}</div>
      <div class="d-flex align-items-center">
        <filter-condition :formData="formData" filterKey="resource_type" />
        <base-select
          v-model="formData.resource_type"
          filterable
          :selectStyle="{maxWidth: '165px'}"
          :options="options.resource_type"
          @dropdownChange="v => dropdownChange('resource_type', v)"
          dropdownItemWordWrap
          :select-props="{ placeholder: $t('bill.text_49'), mode: 'multiple' }" />
      </div>
    </div>
    <div v-if="!$isScopedPolicyMenuHidden('fee_hidden_items.spec') && isShowDimensions('spec')" class="mt-3 d-flex justify-content-between align-items-center">
      <div class="filter-label">{{ $t('meter.bill_impact_factor') }}</div>
      <div class="d-flex align-items-center">
        <filter-condition :formData="formData" filterKey="spec" />
        <base-select
          v-model="formData.spec"
          filterable
          :selectStyle="{maxWidth: '165px'}"
          :options="options.spec"
          @dropdownChange="v => dropdownChange('spec', v)"
          dropdownItemWordWrap
          :select-props="{ placeholder: $t('bill.text_49'), mode: 'multiple' }" />
      </div>
    </div>
    <div v-if="!$isScopedPolicyMenuHidden('fee_hidden_items.financial_unit') && isShowDimensions('financial_unit')" class="mt-3 d-flex justify-content-between align-items-center">
      <div class="filter-label">{{ $t('bill.financial_unit') }}</div>
      <div class="d-flex align-items-center">
        <filter-condition :formData="formData" filterKey="financial_unit" />
        <base-select
          v-model="formData.financial_unit"
          filterable
          :selectStyle="{maxWidth: '165px'}"
          :options="options.financial_unit"
          @dropdownChange="v => dropdownChange('financial_unit', v)"
          dropdownItemWordWrap
          :select-props="{ placeholder: $t('bill.text_49'), mode: 'multiple' }" />
      </div>
    </div>
    <div v-if="!$isScopedPolicyMenuHidden('fee_hidden_items.origin_res_type') && isShowDimensions('origin_res_type')" class="mt-3 d-flex justify-content-between align-items-center">
      <div class="filter-label">{{$t('bill.title.origin_res_type')}}</div>
      <div class="d-flex align-items-center">
        <filter-condition :formData="formData" filterKey="origin_res_type" />
        <base-select
          v-model="formData.origin_res_type"
          filterable
          :selectStyle="{maxWidth: '165px'}"
          :options="options.origin_res_type"
          @dropdownChange="v => dropdownChange('origin_res_type', v)"
          dropdownItemWordWrap
          :select-props="{ placeholder: $t('bill.text_49'), mode: 'multiple' }" />
      </div>
    </div>
    <div v-if="!$isScopedPolicyMenuHidden('fee_hidden_items.product_type') && isShowDimensions('product_type')" class="mt-3 d-flex justify-content-between align-items-center">
      <div class="filter-label">{{ $t('bill.product_type') }}</div>
      <div class="d-flex align-items-center">
        <filter-condition :formData="formData" filterKey="product_type" />
        <base-select
          v-model="formData.product_type"
          filterable
          :selectStyle="{maxWidth: '165px'}"
          :options="options.product_type"
          @dropdownChange="v => dropdownChange('product_type', v)"
          dropdownItemWordWrap
          :select-props="{ placeholder: $t('bill.text_49'), mode: 'multiple' }" />
      </div>
    </div>
    <div v-if="!$isScopedPolicyMenuHidden('fee_hidden_items.external_project_name') && isShowDimensions('external_project_name')" class="mt-3 d-flex justify-content-between align-items-center">
      <div class="filter-label">{{$t('bill.external_project_name')}}</div>
      <div class="d-flex align-items-center">
        <filter-condition :formData="formData" filterKey="external_project_name" />
        <base-select
          v-model="formData.external_project_name"
          filterable
          :selectStyle="{maxWidth: '165px'}"
          :options="options.external_project_name"
          @dropdownChange="v => dropdownChange('external_project_name', v)"
          dropdownItemWordWrap
          :select-props="{ placeholder: $t('bill.text_49'), mode: 'multiple' }" />
      </div>
    </div>
    <div v-if="!$isScopedPolicyMenuHidden('fee_hidden_items.usage_type') && isShowDimensions('usage_type')" class="mt-3 d-flex justify-content-between align-items-center">
      <div class="filter-label">{{$t('bill.usage_type')}}</div>
      <div class="d-flex align-items-center">
        <filter-condition :formData="formData" filterKey="usage_type" />
        <base-select
          v-model="formData.usage_type"
          filterable
          :selectStyle="{maxWidth: '165px'}"
          :options="options.usage_type"
          @dropdownChange="v => dropdownChange('usage_type', v)"
          dropdownItemWordWrap
          :select-props="{ placeholder: $t('bill.text_49'), mode: 'multiple' }" />
      </div>
    </div>
    <div v-if="!$isScopedPolicyMenuHidden('fee_hidden_items.tag') && isShowDimensions('tag')" class="mt-3 d-flex justify-content-between align-items-center">
      <div class="filter-label">{{$t('bill.text_79')}}</div>
      <div class="d-flex justify-content-between" style="width:240px">
        <tag-select
          show-ext-tags
          show-no-value
          v-model="formData.tag"
          :params="tagParams"
          :managerInstance="resourceTagInstance"
          :filterWithoutUserMeta="true"
          :filterWithUserMeta="false"
          ignoreWithUserMetaParam
          withoutTagKey="without_bill_tags"
          withTagKey="with_bill_tags" />
        <a-button v-if="!R.isEmpty(formData.tag)" type="link" style="color: rgb(153, 153, 153);" size="small" @click="removeAllTag()">{{$t('bill.text_105')}}</a-button>
      </div>
    </div>
    <tag-list
      v-if="!R.isEmpty(formData.tag)"
      :tagTree="formData.tag"
      withoutTagKey="without_bill_tags"
      withTagKey="with_bill_tags"
      @removeTag="removeTag" />
    <!-- 资源标签 -->
    <div v-if="!$isScopedPolicyMenuHidden('fee_hidden_items.instance_tag')" class="mt-3 d-flex justify-content-between align-items-center">
      <div class="filter-label">{{$t('dictionary.instance_tag')}}</div>
      <div class="d-flex justify-content-between" style="width:240px">
        <tag-select
          show-ext-tags
          show-no-value
          v-model="formData.instance_tag"
          multiple
          :params="instanceTagParams"
          :managerInstance="resourceInstanceTagInstance"
          :filterWithoutUserMeta="true"
          :filterWithUserMeta="false"
          ignoreWithUserMetaParam
          withoutTagKey="without_instance_tags"
          withTagKey="with_instance_tags" />
        <a-button v-if="!R.isEmpty(formData.instance_tag)" type="link" style="color: rgb(153, 153, 153);" size="small" @click="removeAllInstanceTag()">{{$t('bill.text_105')}}</a-button>
      </div>
    </div>
    <tag-list
      v-if="!R.isEmpty(formData.instance_tag)"
      :tagTree="formData.instance_tag"
      withoutTagKey="without_instance_tags"
      withTagKey="with_instance_tags"
      @removeTag="removeInstanceTag" />
    <div v-if="!$isScopedPolicyMenuHidden('fee_hidden_items.project_tag') && isShowDimensions('project_tag')" class="mt-3 d-flex justify-content-between align-items-center">
      <div class="filter-label">{{$t('dictionary.project_tag')}}</div>
      <div class="d-flex justify-content-between" style="width:240px">
        <tag-select
          show-ext-tags
          show-no-value
          v-model="formData.project_tag"
          multiple
          :params="projectTagParams"
          :managerInstance="resourceProjectTagInstance"
          :filterWithoutUserMeta="true"
          :filterWithUserMeta="false"
          ignoreWithUserMetaParam
          withoutTagKey="without_project_tags"
          withTagKey="with_project_tags" />
        <a-button v-if="!R.isEmpty(formData.project_tag)" type="link" style="color: rgb(153, 153, 153);" size="small" @click="removeAllProjectTag()">{{$t('bill.text_105')}}</a-button>
      </div>
    </div>
    <tag-list
      v-if="!R.isEmpty(formData.project_tag)"
      :tagTree="formData.project_tag"
      withoutTagKey="without_project_tags"
      withTagKey="with_project_tags"
      @removeTag="removeProjectTag" />
  </div>
</template>

<script>
import * as R from 'ramda'
import { mapGetters, mapState } from 'vuex'
import { CHARGE_TYPES } from '@Bill/constants'
import TagSelect from '@/sections/TagSelect'
import { uuid } from '@/utils/utils'
import AnalysisesMixin from '../mixins/analysises'
import TagList from './TagList'
import FilterCondition from './Condition'

export default {
  name: 'BillAnalysisFilter',
  components: {
    TagSelect,
    TagList,
    FilterCondition,
  },
  mixins: [AnalysisesMixin],
  props: {
    formData: {
      type: Object,
    },
    showDimensions: {
      type: Array,
    },
    billType: String || Array,
    billShared: {
      type: Boolean,
      default: false,
    },
    projectShared: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      R,
      options: {
        brand: [],
        account: [],
        linked_name: [],
        region: [],
        origin_region: [],
        project: [],
        chargeType: CHARGE_TYPES,
        domain: [],
        cloudprovider_name: [],
        resource_type: [],
        spec: [],
        financial_unit: [],
        origin_res_type: [],
        external_project_name: [],
        usage_type: [],
        product_type: [],
        origin_usage_type: [],
        origin_record_type: [],
        condition: [
          { id: 'equals', name: '=' },
          { id: 'not_equals', name: '!=' },
        ],
      },
    }
  },
  computed: {
    ...mapGetters(['isAdminMode', 'isDomainMode', 'scope']),
    ...mapState('common', {
      enableCostConversion: state => state.bill.globalConfig.cost_conversion_available,
    }),
    tagParams () {
      const {
        platform_brand,
        account_id,
        cloudprovider_id,
        region_ext_id,
        charge_type,
      } = this.formData
      const { start_date = '', end_date = '' } = this.formData.date
      const startDate = this.$moment(start_date.substr(0, start_date.length - 2)).format('YYYYMMDD')
      const endDate = this.$moment(end_date.substr(0, end_date.length - 2)).format('YYYYMMDD')
      return {
        platform_brand,
        account_id,
        cloudprovider_id,
        region_ext_id,
        charge_type,
        start_day: startDate,
        end_day: endDate,
        is_prepaid_amortizing: this.billShared,
        is_project_sharing: this.projectShared,
      }
    },
    instanceTagParams () {
      const {
        platform_brand,
        account_id,
        cloudprovider_id,
        region_ext_id,
        charge_type,
      } = this.formData
      const { start_date, end_date } = this.formData.date
      const startDate = this.$moment(start_date.substr(0, start_date.length - 2)).format('YYYYMMDD')
      const endDate = this.$moment(end_date.substr(0, end_date.length - 2)).format('YYYYMMDD')
      return {
        platform_brand,
        account_id,
        cloudprovider_id,
        region_ext_id,
        charge_type,
        start_day: startDate,
        end_day: endDate,
        resources: 'payment_bill',
        key_prefix: ['user:', 'ext:'],
        is_prepaid_amortizing: this.billShared,
        is_project_sharing: this.projectShared,
      }
    },
    projectTagParams () {
      const {
        platform_brand,
        account_id,
        cloudprovider_id,
        region_ext_id,
        charge_type,
      } = this.formData
      const { start_date = '', end_date = '' } = this.formData.date
      const startDate = this.$moment(start_date.substr(0, start_date.length - 2)).format('YYYYMMDD')
      const endDate = this.$moment(end_date.substr(0, end_date.length - 2)).format('YYYYMMDD')
      return {
        platform_brand,
        account_id,
        cloudprovider_id,
        region_ext_id,
        charge_type,
        start_day: startDate,
        end_day: endDate,
        resources: 'payment_bill',
        key_prefix: ['user:', 'ext:'],
        is_prepaid_amortizing: this.billShared,
        is_project_sharing: this.projectShared,
      }
    },
    billTypeOpts () {
      let opts = [
        { id: 'stat_value', name: this.$t('bill.text_125') },
        { id: 'stat_value_sec', name: this.$t('bill.converted_amount') },
        { id: 'gross_value', name: this.$t('bill.bill_type.gross_value') },
        { id: 'paid_value', name: this.$t('bill.bill_type.paid_value') },
        { id: 'discount_value', name: this.$t('bill.bill_type.discount_value_info') },
      ]
      if (!this.enableCostConversion) {
        opts = opts.filter(item => item.id !== 'stat_value_sec')
      }
      return opts
    },
  },
  watch: {
    'formData.date': {
      handler: function (val) {
        this.clearFilterOptions()
      },
    },
  },
  created () {
    this.resourceTagInstance = new this.$Manager('res_tag_details', 'v1')
    this.resourceInstanceTagInstance = new this.$Manager('instance_tag_details', 'v1')
    this.resourceProjectTagInstance = new this.$Manager('project_tag_details', 'v1')
    this.resourceM = new this.$Manager('payment_bills', 'v1')
  },
  methods: {
    clearFilterOptions () {
      for (const field in this.options) {
        if (field !== 'chargeType' && field !== 'condition' && this.options[field].length) {
          this.fetchDistinct(field)
        }
      }
    },
    dropdownChange (field, open) {
      if (this.options[field] && this.options[field].length) return
      if (open) {
        this.fetchDistinct(field)
      }
    },
    getDistinctParams (field) {
      const { start_date, end_date } = this.formData.date
      const ret = {
        admin: this.isAdmin,
        scope: this.scope,
        field,
        $t: uuid(),
        start_date,
        end_date,
      }
      return ret
    },
    fetchDistinct (field) {
      if (!this.resourceM) this.resourceM = new this.$Manager('payment_bills', 'v1')
      if (field === 'account') {
        this.fetchAccountDistinct()
        return
      }
      const params = this.getDistinctParams(field)
      let id = 'distinct-field'
      if (field === 'cloudprovider_name') {
        id += 's'
        params.field = ['cloudprovider_id', 'cloudprovider_name']
      }
      this.resourceM.get({
        id,
        params,
      }).then(res => {
        const ret = []
        if (field === 'cloudprovider_name') {
          const { fields = [] } = res.data || {}
          fields.map(item => {
            let name = item.cloudprovider_name
            const len = fields.filter(l => l.cloudprovider_name === item.cloudprovider_name).length
            if (len > 1) {
              name = `${item.cloudprovider_name} (${(item.cloudprovider_id || '').substring(0, 6)})`
            }
            ret.push({ id: item.cloudprovider_id, name: name })
          })
        } else {
          const data = (res.data || {})[field] || []
          data.filter(item => item).map(key => {
            const retItem = { id: key, name: key }
            if (field === 'brand') {
              retItem.name = this.getNameI18n(key, 'brand')
            } else if (field === 'account') {
              retItem.name = this.getNameI18n(key, 'account')
            } else if (field === 'resource_type') {
              retItem.name = this.getNameI18n(key, 'resource_type')
            }
            ret.push(retItem)
          })
        }
        ret.sort((a, b) => {
          return a.name.localeCompare(b.name)
        })
        const originOptions = this.options[field]
        this.options[field] = ret
        let fField = field
        if (field === 'brand') {
          fField = 'platform_brand'
        }
        if (field === 'cloudprovider_name') {
          fField = 'cloudprovider'
        }
        if (this.formData[fField] && this.formData[fField].length) {
          this.formData[fField].map(id => {
            const target = originOptions.filter(item => item.id === id)
            if (target.length && !this.options[field].some(item => item.id === id)) {
              this.options[field].push(target[0])
            }
          })
        }
      }).catch(err => {
        console.error(err)
      })
    },
    fetchAccountDistinct () {
      new this.$Manager('meter_cloudaccounts', 'v1').get({
        id: 'distinct-accounts',
      }).then(res => {
        const { data = [] } = res.data || {}
        const ret = []
        data.filter(item => item.name).map(item => {
          const retItem = { id: item.name, name: this.getNameI18n(item.name, 'account') }
          if (item.description) retItem.name = `${item.name}(${item.description})`
          ret.push(retItem)
        })
        ret.sort((a, b) => {
          return a.name.localeCompare(b.name)
        })
        this.options.account = ret
        if (this.formData.account && this.formData.account.length) {
          this.formData.account = this.formData.account.filter(id => ret.some(item => item.id === id))
        }
      }).catch(err => {
        console.error(err)
      })
    },
    uniqueArr (arr, byId = 'item_id') {
      const obj = {}
      arr.forEach(val => {
        obj[val[byId]] = val
      })
      return Object.values(obj)
    },
    removeTag (tag) {
      if (tag.key === 'without_user_meta') {
        this.$delete(this.formData.tag, 'without_user_meta')
      } else if (tag.key === 'with_user_meta') {
        this.$delete(this.formData.tag, 'with_user_meta')
      } else {
        this.$delete(this.formData.tag, tag.key)
      }
      // this.fetchData()
    },
    removeAllTag () {
      this.formData.tag = {}
      // this.fetchData()
    },
    removeInstanceTag (tag) {
      if (tag.key === 'without_user_meta') {
        this.$delete(this.formData.instance_tag, 'without_user_meta')
      } else if (tag.key === 'with_user_meta') {
        this.$delete(this.formData.instance_tag, 'with_user_meta')
      } else {
        this.$delete(this.formData.instance_tag, tag.key)
      }
    },
    removeAllInstanceTag () {
      this.formData.instance_tag = {}
    },
    removeProjectTag (tag) {
      if (tag.key === 'without_user_meta') {
        this.$delete(this.formData.project_tag, 'without_user_meta')
      } else if (tag.key === 'with_user_meta') {
        this.$delete(this.formData.project_tag, 'with_user_meta')
      } else {
        this.$delete(this.formData.project_tag, tag.key)
      }
    },
    removeAllProjectTag () {
      this.formData.project_tag = {}
    },
    tagChangeHandle () {
      // this.fetchData()
    },
    getTagTitle (key, value) {
      return this.$t('bill.text_102', [key.replace('user:', ''), value])
    },
    isShowDimensions (v) {
      if (this.showDimensions && this.showDimensions.length > 0) {
        return this.showDimensions.includes(v)
      }
      return true
    },
    billTypeChange (val) {
      const next = Array.isArray(val) ? val.filter(Boolean) : (val ? [val] : [])
      if (!next.length) {
        this.$message.warning(this.$t('bill.bill_type_required'))
        return
      }
      this.$emit('billTypeChange', next)
    },
  },
}
</script>
<style lang="less" scoped>
.tag-list {
  margin-top: 10px;;
  .tag {
    max-width: 100%;
    line-height: 20px;
    margin-right: 10px;
    padding: 0 18px 0 4px;
    font-size: 12px;
    border-style: solid;
    border-width: 1px;
    margin-bottom: 10px;
    position: relative;
  }
}
</style>
